import { useEffect } from "react";
import { useAuthStore } from "../../stores/auth.store";

export const useAuth = () => {
	const { isAuthenticated, isLoading, checkAuth } = useAuthStore();

	useEffect(() => {
		checkAuth();
	}, [checkAuth]);

	return {
		isAuthenticated,
		isLoading,
	};
};
